import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function LifestyleCardModal({ post, isOpen, onClose }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        {/* BACKDROP */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/70 backdrop-blur-sm" />
        </Transition.Child>

        {/* MODAL CONTAINER */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95 translate-y-4"
            enterTo="opacity-100 scale-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100 translate-y-0"
            leaveTo="opacity-0 scale-95 translate-y-4"
          >
            <Dialog.Panel className="relative w-full max-w-4xl transform overflow-hidden rounded-xl bg-white dark:bg-dark-900 p-6 text-left shadow-2xl transition-all border border-gray-600/50">
              {/* CLOSE BUTTON */}
              <button
                onClick={onClose}
                aria-label="Close modal"
                className="
                  absolute top-4 right-4 px-3
                  text-gray-500 hover:text-gray-900
                  dark:text-gray-400 dark:hover:text-white
                  text-2xl font-semibold
                  transition-colors duration-200
                "
              >
                ✕
              </button>

              <Dialog.Title className="text-2xl font-bold mb-4 local-theme-text-md pr-8">
                {post.title}
              </Dialog.Title>

              <Carousel
                showThumbs={false}
                infiniteLoop
                autoPlay
                showStatus={false}
                interval={3000}
              >
                {post.images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`${post.title} ${index + 1}`}
                    className="max-h-[70vh] object-contain"
                  />
                ))}
              </Carousel>

              <p className="mt-4 local-theme-text-xs">{post.description}</p>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

export default LifestyleCardModal;
